import { render } from "./KontaktPthGjilan.vue?vue&type=template&id=902b0e8c"
import script from "./KontaktPthGjilan.vue?vue&type=script&lang=js"
export * from "./KontaktPthGjilan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__